<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Compensation and Benefits Employee List" @click="navigateToEmployeeList">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link v-if="!isMobile" appId="compensation" pageId="compensation-benefits" color="white"></help-link>
                    <v-btn v-if="!loading&&hasSalaryAndPay" dark icon small @click="previewPdf" title="Export to PDF" :loading="loading_pdf">
                        <v-icon>fas fa-file-pdf</v-icon>
                    </v-btn>
                    <v-btn v-if="!loading&&!hasSalaryAndPay&&hasEditRights" dark icon small @click="copyPrevious" title="Copy from previous year">
                        <v-icon>copy_all</v-icon>
                    </v-btn>
                    <v-chip v-if="!loading" label dark outline :class="overallStatus.class" :title="`Overall Status: ${overallStatus.status}`">
                        <b>{{ overallStatus.status }}</b>
                    </v-chip>
                    <v-menu v-if="!loading" left v-model="menu_status" offset-y > 
                        <template v-slot:activator="{ on }">
                            <v-btn color="primary" dark v-on="on">
                                &nbsp;&nbsp;CY {{fiscalYear}}&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-tile v-for="(item,index) in fiscal_years" :key="index" @click="setSelectedYear(item)" :title="`View ${item.fiscalYear} Compensation & Benefits`">
                                <v-list-tile-title small>CY {{item.fiscalYear}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="2" style="margin:1px -3px 0px -3px;"></v-progress-linear> 
            </v-card>

            <!-- EMPLOYEE DETAILS -->
            <v-card v-if="allocation" class="elevation-1 mt-5">
                <v-toolbar flat height="35" @click="employeeSectionVisible=!employeeSectionVisible" class="clickable">
                    <span class="font-weight-bold primary--text">EMPLOYEE</span>
                    <v-btn @click="showAllEmployees" icon title="Select other employee">
                        <v-icon>list</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn v-if="employeeSectionVisible" icon title="Minimize">
                        <v-icon>expand_less</v-icon>
                    </v-btn>
                    <v-btn v-if="!employeeSectionVisible" icon title="Expand">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="employeeSectionVisible">
                    <v-layout row wrap> 
                        <v-flex xs12 sm6>
                            <v-layout row wrap :class="isMobile?'form-data-mobile':'form-data'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Employee Name :
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                    <v-chip small class="user-chip-container" @click="viewUserProfile(allocation.user, $store.state.userId)">
                                        <v-avatar>
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(allocation.user.userId)"></v-img>
                                        </v-avatar>
                                        <b>{{allocation.user.firstName}} {{allocation.user.lastName}}</b>
                                    </v-chip>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'form-data-mobile':'form-data'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Employee Id : 
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                <b>{{allocation.user.employeeId}}</b>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'form-data-mobile':'form-data'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Position : 
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                    <b>{{allocation.user.position}}</b>
                                </v-flex>  
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-layout row wrap :style="isMobile?'padding:0px 0px 0px 10px':'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Hire Date : 
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                <b>
                                    <span v-if="allocation.user.hireDate!=null">{{allocation.user.hireDate|moment('MMM DD, YYYY')}}</span>
                                    <span v-else class="orange--text">Not updated</span>
                                </b>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :style="isMobile?'padding:0px 0px 0px 10px':'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Employment Status :
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                    <b v-if="isDeactivted" :class="commonfn.getStatusColor(allocation.user.employmentStatus)">{{commonfn.getStatusDescription(allocation.user.employmentStatus)}} on {{ allocation.user.deactivatedOn | moment('MMM DD, YYYY') }}</b>
                                    <b v-else-if="isResignedOrTerminated" :class="commonfn.getStatusColor(allocation.user.employmentStatus)">{{commonfn.getStatusDescription(allocation.user.employmentStatus)}} on {{ allocation.user.endDate | moment('MMM DD, YYYY') }}</b>
                                    <b v-else :class="commonfn.getStatusColor(allocation.user.employmentStatus)">{{commonfn.getStatusDescription(allocation.user.employmentStatus)}}</b>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :style="isMobile?'padding:0px 0px 0px 10px':'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Salary Type :
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                    <b>{{commonfn.getSalaryTypeName(allocation.user.salaryType)}}</b>
                                </v-flex>  
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <!-- SALARY & PAY DETAILS -->
            <v-card v-if="allocation" class="elevation-1 mt-5">
                <v-toolbar flat height="35" @click="salarySectionVisible=!salarySectionVisible" class="clickable">
                    <span :class="hasSalaryAndPay?'font-weight-bold primary--text':'primary--text'">SALARY & PAY</span>
                    <v-spacer></v-spacer>
                    <v-btn v-if="salarySectionVisible" icon title="Minimize">
                        <v-icon>expand_less</v-icon>
                    </v-btn>
                    <v-btn v-if="!salarySectionVisible" icon title="Expand">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </v-toolbar>
                <div v-if="salarySectionVisible">
                    <v-data-table
                        v-if="hasSalaryAndPay"
                        :headers="isMonthlySalaryType?header_compensation:header_compensation_hourly"
                        :items="allocation.compensation"
                        :hide-headers="isMobile"
                        hide-actions
                    >
                        <template v-slot:items="props">

                            <!-- mobile view -->
                            <tr v-if="isMobile">
                                <td :colspan="isMonthlySalaryType?header_compensation.length:header_compensation_hourly.length" class="pa-1">
                                    <v-card class="elevation-1">
                                        <v-layout row wrap align-center class="section-layout">
                                            <v-flex xs12 class="text-xs-left mt-5">
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Pay Grade</div>
                                                        <div>{{props.item.payGrade}}</div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div v-if="isMonthlySalaryType">
                                                            <div class="caption grey--text text--darken-1">Monthly Salary</div>
                                                            <div>{{numFormat.formatNumber(props.item.monthlyBasicSalary)}}</div>
                                                        </div>
                                                        <div v-else>
                                                            <div class="caption grey--text text--darken-1">Hourly Rate</div>
                                                            <div>{{numFormat.formatNumber(props.item.hourlySalary)}}</div>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div v-if="isMonthlySalaryType">
                                                            <div class="caption grey--text text--darken-1">Annual Salary</div>
                                                            <div>{{numFormat.formatNumber((props.item.monthlyBasicSalary*12))}}</div>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">OT Pay Eligible</div>
                                                        <div>
                                                            <span v-if="props.item.otPayEligible">Yes</span>
                                                            <span v-else>No</span>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">ND Pay ELigible</div>
                                                        <div>
                                                            <span v-if="props.item.ndPayEligible">Yes</span>
                                                            <span v-else>No</span>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Effective Date</div>
                                                        <div>{{ props.item.effectiveDate | moment('MMM DD, YYYY')}}</div>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Status</div>
                                                        <div :class="commonfn.getStatusColor(props.item.status)">{{ commonfn.getStatusDescription(props.item.status) }}</div> 
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card>
                                </td>
                            </tr>
                            
                            <!-- desktop view -->
                            <tr v-else>
                                <td>{{props.item.payGrade}}</td>
                                <td class="text-xs-right">
                                    <span v-if="isMonthlySalaryType">{{numFormat.formatNumber(props.item.monthlyBasicSalary)}}</span>
                                    <span v-else>{{numFormat.formatNumber(props.item.hourlySalary)}}</span>
                                </td>
                                <td class="text-xs-right" v-if="isMonthlySalaryType">{{numFormat.formatNumber((props.item.monthlyBasicSalary*12))}}</td>
                                <td>
                                    <span v-if="props.item.otPayEligible">Yes</span>
                                    <span v-else>No</span>
                                </td>
                                <td>
                                    <span v-if="props.item.ndPayEligible">Yes</span>
                                    <span v-else>No</span>
                                </td>
                                <td>
                                    {{ props.item.effectiveDate | moment('MMM DD, YYYY')}}
                                </td>
                                <td>
                                <span :class="commonfn.getStatusColor(props.item.status)">{{ commonfn.getStatusDescription(props.item.status) }}</span> 
                                </td>
                            </tr>

                        </template>
                    </v-data-table>
                    <v-layout v-else row wrap>
                        <v-flex xs12 sm12>
                            <p class="ml-25 grey--text text--darken-1">
                                No Salary & Pay record found for the selected year and employee. Click <b>Manage Salary & Pay</b> to get started.
                            </p>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="primary no-uppercase" small @click="managePage('salary-history')">
                            Manage Salary & Pay
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>

            <!-- LEAVE BENEFITS -->
            <v-card v-if="hasSalaryAndPay" class="elevation-1 mt-5">
                <v-toolbar flat height="35" @click="leavesSectionVisible=!leavesSectionVisible" class="clickable">
                    <span :class="allocation.leaves.length?'font-weight-bold primary--text':'primary--text'">LEAVE BENEFITS</span>
                    <v-spacer></v-spacer>
                    <v-btn v-if="leavesSectionVisible" icon title="Minimize">
                        <v-icon>expand_less</v-icon>
                    </v-btn>
                    <v-btn v-if="!leavesSectionVisible" icon title="Expand">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </v-toolbar>
                <div v-if="leavesSectionVisible">
                    <v-data-table
                        v-if="allocation.leaves.length"
                        :headers="headers_leaves"
                        :items="allocation.leaves"
                        :hide-headers="isMobile"
                        hide-actions
                    >
                        <template v-slot:items="props">

                            <!-- mobile view -->
                            <tr v-if="isMobile">
                                <td :colspan="headers_leaves.length" class="pa-1">
                                    <v-card class="elevation-1">
                                        <v-layout row wrap align-center class="section-layout">
                                            <v-flex xs12 class="text-xs-left mt-5">
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Type</div>
                                                        <div>{{props.item.leaveName}}</div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Annual Credits</div>
                                                        <div>{{numFormat.formatNumber(props.item.annualAllocation)}}</div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Cash Conversion Limit</div>
                                                        <div>{{numFormat.formatNumber(props.item.convertibleToCash)}}</div>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Carry-Over Limit</div>
                                                        <div>{{numFormat.formatNumber(props.item.toCarryOverNextYear)}}</div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Pro-Rated</div>
                                                        <div>
                                                            <span v-if="props.item.prorated">Yes</span>
                                                            <span v-else>No</span>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Status</div>
                                                    <div :class="commonfn.getStatusColor(props.item.status)">{{ commonfn.getStatusDescription(props.item.status) }}</div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card>
                                </td>
                            </tr>

                            <!-- desktop view -->
                            <tr v-else>
                                <td>{{ props.item.leaveName }}</td>
                                <td>{{numFormat.formatNumber(props.item.annualAllocation)}}</td>
                                <td>{{numFormat.formatNumber(props.item.convertibleToCash)}}</td>
                                <td>{{numFormat.formatNumber(props.item.toCarryOverNextYear)}}</td>
                                <td>
                                    <span v-if="props.item.prorated">Yes</span>
                                    <span v-else>No</span>
                                </td>
                                <td>
                                    <span :class="commonfn.getStatusColor(props.item.status)">{{ commonfn.getStatusDescription(props.item.status) }}</span> 
                                </td>
                            </tr>

                        </template>
                    </v-data-table>
                    <v-layout v-else row wrap>
                        <v-flex xs12 sm12>
                            <p class="ml-25 grey--text text--darken-1">
                                No Leave Benefits record found for the selected year and employee. Click <b>Manage Leave Benefits</b> to get started.
                            </p>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="primary no-uppercase" small @click="managePage('leave-benefits')">
                            Manage Leave Benefits
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>
            
            <!-- DE MINIMIS BENEFITS -->
            <v-card v-if="hasSalaryAndPay" class="elevation-1 mt-5">
                <v-toolbar flat height="35" @click="deminimisSectionVisible=!deminimisSectionVisible" class="clickable">
                    <span :class="allocation.deminimis.length?'font-weight-bold primary--text':'primary--text'">DE MINIMIS BENEFITS</span>
                    <v-spacer></v-spacer>
                    <v-btn v-if="deminimisSectionVisible" icon title="Minimize">
                        <v-icon>expand_less</v-icon>
                    </v-btn>
                    <v-btn v-if="!deminimisSectionVisible" icon title="Expand">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </v-toolbar>
                <div v-if="deminimisSectionVisible">
                    <v-data-table
                        v-if="allocation.deminimis.length"
                        :headers="header_deminimis"
                        :items="allocation.deminimis"
                        :hide-headers="isMobile"
                        hide-actions
                    >
                        <template v-slot:items="props">

                            <!-- mobile view -->
                            <tr v-if="isMobile">
                                <td :colspan="header_deminimis.length" class="pa-1">
                                    <v-card class="elevation-1">
                                        <v-layout row wrap align-center class="section-layout">
                                            <v-flex xs12 class="text-xs-left mt-5">
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Type</div>
                                                        <div>{{props.item.deminimisName}}</div>
                                                    </v-flex>
                                                    <v-flex xs8>
                                                        <div class="caption grey--text text--darken-1">Payout On</div>
                                                        <pay-on-month :payOnMonth="props.item.payOnMonth2"></pay-on-month>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Payout Schedule</div>
                                                        <div>{{ deductionTypes.getDescription(props.item.payoutMode) }}</div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Monthly Amount</div>
                                                        <div>{{ numFormat.formatNumber(props.item.monthlyAmount) }}</div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Cutoff Amount</div>
                                                        <div>
                                                            <span v-if="props.item.payoutMode==3">{{numFormat.formatNumber((props.item.monthlyAmount/2))}}</span>
                                                            <span v-else>{{numFormat.formatNumber(props.item.monthlyAmount)}}</span>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Annual Amount</div>
                                                        <div>{{ numFormat.formatNumber(props.item.annualPayment) }}</div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Status</div>
                                                        <div :class="commonfn.getStatusColor(props.item.status)">{{ commonfn.getStatusDescription(props.item.status) }}</div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card>
                                </td>
                            </tr>

                            <!-- desktop view -->
                            <tr v-else>
                                <td>{{ props.item.deminimisName }}</td>
                                <td>
                                    <pay-on-month :payOnMonth="props.item.payOnMonth2"></pay-on-month>
                                </td>
                                <td>{{ deductionTypes.getDescription(props.item.payoutMode) }}</td>
                                <td class="text-xs-right">{{ numFormat.formatNumber(props.item.monthlyAmount) }}</td>
                                <td class="text-xs-right">
                                    <span v-if="props.item.payoutMode==3">{{numFormat.formatNumber((props.item.monthlyAmount/2))}}</span>
                                    <span v-else>{{numFormat.formatNumber(props.item.monthlyAmount)}}</span>
                                </td>
                                <td class="text-xs-right">{{ numFormat.formatNumber(props.item.annualPayment) }}</td>
                                <td>
                                    <span :class="commonfn.getStatusColor(props.item.status)">{{ commonfn.getStatusDescription(props.item.status) }}</span> 
                                </td>
                            </tr>

                        </template>
                    </v-data-table>
                    <v-layout v-else row wrap>
                        <v-flex xs12 sm12>
                            <p class="ml-25 grey--text text--darken-1">
                                No De Minimis Benefits record found for the selected year and employee. Click <b>Manage De Minimis Benefits</b> to get started.
                            </p>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="primary no-uppercase" small @click="managePage('deminimis-benefits')">
                            Manage De Minimis Benefits
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>

            <!-- FRINGE BENEFITS -->
            <v-card v-if="hasSalaryAndPay" class="elevation-1 mt-5">
                <v-toolbar flat height="35" @click="fringeSectionVisible=!fringeSectionVisible" class="clickable">
                    <span :class="allocation.fringeBenefits.length?'font-weight-bold primary--text':'primary--text'">FRINGE BENEFITS</span>
                    <v-spacer></v-spacer>
                    <v-btn v-if="fringeSectionVisible" icon title="Minimize">
                        <v-icon>expand_less</v-icon>
                    </v-btn>
                    <v-btn v-if="!fringeSectionVisible" icon title="Expand">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </v-toolbar>
                <div v-if="fringeSectionVisible">
                    <v-data-table
                        v-if="allocation.fringeBenefits.length"
                        :headers="headers_fringe"
                        :items="allocation.fringeBenefits"
                        :hide-headers="isMobile"
                        hide-actions
                    >
                        <template v-slot:items="props">

                            <!-- mobile view -->
                            <tr v-if="isMobile">
                                <td :colspan="headers_fringe.length" class="pa-1">
                                    <v-card class="elevation-1">
                                        <v-layout row wrap align-center class="section-layout">
                                            <v-flex xs12 class="text-xs-left mt-5">
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Type</div>
                                                        <div>{{props.item.benefitName}}</div>
                                                    </v-flex>
                                                    <v-flex xs8>
                                                        <div class="caption grey--text text--darken-1">Payout On</div>
                                                        <pay-on-month :payOnMonth="props.item.payOnMonth2"></pay-on-month>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Payout Schedule</div>
                                                        <div>{{ deductionTypes.getDescription(props.item.payoutMode) }}</div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Monthly Amount</div>
                                                        <div>{{ numFormat.formatNumber(props.item.monthlyAmount) }}</div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Cutoff Amount</div>
                                                        <div>
                                                            <span v-if="props.item.payoutMode==3">{{numFormat.formatNumber((props.item.monthlyAmount/2))}}</span>
                                                            <span v-else>{{numFormat.formatNumber(props.item.monthlyAmount)}}</span>
                                                        </div>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Annual Amount</div>
                                                        <div>{{ numFormat.formatNumber(props.item.annualPayment) }}</div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Status</div>
                                                        <div :class="commonfn.getStatusColor(props.item.status)">{{ commonfn.getStatusDescription(props.item.status) }}</div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card>
                                </td>
                            </tr>

                            <!-- desktop view -->
                            <tr v-else>
                                <td>{{ props.item.benefitName }}</td>
                                <td>
                                    <pay-on-month :payOnMonth="props.item.payOnMonth2"></pay-on-month>
                                </td>
                                <td>{{ deductionTypes.getDescription(props.item.payoutMode) }}</td>
                                <td class="text-xs-right">{{ numFormat.formatNumber(props.item.monthlyAmount) }}</td>
                                <td class="text-xs-right">
                                    <span v-if="props.item.payoutMode==3">{{numFormat.formatNumber((props.item.monthlyAmount/2))}}</span>
                                    <span v-else>{{numFormat.formatNumber(props.item.monthlyAmount)}}</span>
                                </td>
                                <td class="text-xs-right">{{ numFormat.formatNumber(props.item.annualPayment) }}</td>
                                <td>
                                    <span :class="commonfn.getStatusColor(props.item.status)">{{ commonfn.getStatusDescription(props.item.status) }}</span> 
                                </td>
                            </tr>

                        </template>
                    </v-data-table>
                    <v-layout v-else row wrap>
                        <v-flex xs12 sm12>
                            <p class="ml-25 grey--text text--darken-1">
                                No Fringe Benefits record found for the selected year and employee. Click <b>Manage Fringe Benefits</b> to get started.
                            </p>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="primary no-uppercase" small @click="managePage('fringe-benefits')">
                            Manage Fringe Benefits
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>

            <!-- OTHER BENEFITS -->
            <v-card v-if="hasSalaryAndPay" class="elevation-1 mt-5 mb-5">
                <v-toolbar flat height="35" @click="otherSectionVisible=!otherSectionVisible" class="clickable">
                    <span :class="allocation.otherBenefits.length?'font-weight-bold primary--text':'primary--text'">OTHER BENEFITS</span>
                    <v-spacer></v-spacer>
                    <v-btn v-if="otherSectionVisible" icon title="Minimize">
                        <v-icon>expand_less</v-icon>
                    </v-btn>
                    <v-btn v-if="!otherSectionVisible" icon title="Expand">
                        <v-icon>expand_more</v-icon>
                    </v-btn>
                </v-toolbar>
                <div v-if="otherSectionVisible">
                    <v-data-table
                        v-if="allocation.otherBenefits.length"
                        :headers="headers_otherbenefits"
                        :items="allocation.otherBenefits"
                        :hide-headers="isMobile"
                        hide-actions
                    >
                        <template v-slot:items="props">

                            <!-- mobile view -->
                            <tr v-if="isMobile">
                                <td :colspan="headers_otherbenefits.length" class="pa-1">
                                    <v-card class="elevation-1">
                                        <v-layout row wrap align-center class="section-layout">
                                            <v-flex xs12 class="text-xs-left mt-5">
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Type</div>
                                                        <div>{{props.item.otherBenefitName}}</div>
                                                    </v-flex>
                                                    <v-flex xs8>
                                                        <div class="caption grey--text text--darken-1">Payout On</div>
                                                        <pay-on-month :payOnMonth="props.item.payOnMonth2"></pay-on-month>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Payout Schedule</div>
                                                        <div>{{ deductionTypes.getDescription(props.item.payoutMode) }}</div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Rate</div>
                                                        <div v-if="is13thMonthPay(props.item)">
                                                            <span v-if="props.item.thirteenthMonthPayRate==1">Pro-rated</span>
                                                            <span v-if="props.item.thirteenthMonthPayRate==2">Current month salary</span>
                                                        </div>
                                                        <div v-else>
                                                            N/A
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Monthly Amount</div>
                                                        <div v-if="is13thMonthPay(props.item)">
                                                            N/A
                                                        </div>
                                                        <div v-else>
                                                            {{ numFormat.formatNumber(props.item.monthlyAmount) }}
                                                        </div>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout row>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Cutoff Amount</div>
                                                        <div v-if="is13thMonthPay(props.item)">
                                                            N/A
                                                        </div>
                                                        <div v-else>
                                                            <span v-if="props.item.payoutMode==3">{{numFormat.formatNumber((props.item.monthlyAmount/2))}}</span>
                                                            <span v-else>{{numFormat.formatNumber(props.item.monthlyAmount)}}</span>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Annual Amount</div>
                                                        <div v-if="is13thMonthPay(props.item)">
                                                            N/A
                                                        </div>
                                                        <div v-else>
                                                            {{ numFormat.formatNumber(props.item.annualPayment) }}
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <div class="caption grey--text text--darken-1">Status</div>
                                                        <div :class="commonfn.getStatusColor(props.item.status)">{{ commonfn.getStatusDescription(props.item.status) }}</div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card>
                                </td>
                            </tr>

                            <!-- desktop view -->
                            <tr v-else>
                                <td>{{ props.item.otherBenefitName }}</td>
                                <td>
                                    <pay-on-month :payOnMonth="props.item.payOnMonth2"></pay-on-month>
                                </td>
                                <td>{{ deductionTypes.getDescription(props.item.payoutMode) }}</td>
                                <td>
                                    <span v-if="is13thMonthPay(props.item)">
                                        <span v-if="props.item.thirteenthMonthPayRate==1">Pro-rated</span>
                                        <span v-if="props.item.thirteenthMonthPayRate==2">Current month salary</span>
                                    </span>
                                    <span v-else>
                                        N/A
                                    </span>
                                </td>
                                <td class="text-xs-right">
                                    <span v-if="is13thMonthPay(props.item)">
                                        N/A
                                    </span>
                                    <span v-else>
                                        {{ numFormat.formatNumber(props.item.monthlyAmount) }}
                                    </span>
                                </td>
                                <td class="text-xs-right">
                                    <span v-if="is13thMonthPay(props.item)">
                                    N/A
                                    </span>
                                    <span v-else>
                                        <span v-if="props.item.payoutMode==3">{{numFormat.formatNumber((props.item.monthlyAmount/2))}}</span>
                                        <span v-else>{{numFormat.formatNumber(props.item.monthlyAmount)}}</span>
                                    </span>
                                </td>
                                <td class="text-xs-right">
                                    <span v-if="is13thMonthPay(props.item)">
                                    N/A
                                    </span>
                                    <span v-else>
                                        {{ numFormat.formatNumber(props.item.annualPayment) }}
                                    </span>
                                </td>
                                <td>
                                    <span :class="commonfn.getStatusColor(props.item.status)">{{ commonfn.getStatusDescription(props.item.status) }}</span> 
                                </td>
                            </tr>
                            
                        </template>
                    </v-data-table>
                    <v-layout v-else row wrap>
                        <v-flex xs12 sm12>
                            <p class="ml-25 grey--text text--darken-1">
                                No Other Benefits record found for the selected year and employee. Click <b>Manage Other Benefits</b> to get started.
                            </p>
                        </v-flex>
                    </v-layout>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="primary no-uppercase" small @click="managePage('other-benefits')">
                            Manage Other Benefits
                        </v-btn>
                    </v-card-actions>
                </div>
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" ref="commentsRef" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPdfPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>
        <v-dialog v-model="dialogAllocHistory" persistent width="600">
            <alloc-history ref="allocHistoryRef" :dialogAllocHistory.sync="dialogAllocHistory" @send="copyHandler"></alloc-history>
        </v-dialog>
        <v-dialog v-model="dialogAllEmployees" width="700" persistent>
            <view-all-employees ref="refAllEmployees" :dialogAllEmployees.sync="dialogAllEmployees" @send="viewOtherEmployee"></view-all-employees>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import allocationApi from '@/api/allocation'
import commonfn from '@/common/functions'       //for refactor
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import salaryTypes from '@/constants/salary-types'
import awsS3Helper from '@/helpers/aws-s3'
import numFormat from '@/common/num_format'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'
import userPrefs from '@/helpers/user-prefs'
import deductionTypes from '@/helpers/deduction-types'
import { hasEditRights, hasApproverRights } from '@/helpers/access-permissions'

export default {     
    name: 'CompensationUserDetails',
    metaInfo: {
        title: 'Compensation User Details',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Compensation User Details' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
        'preview': () => import('@/components/FilePreview/Preview'),
        'pay-on-month': () => import('@/components/Allocation/PayOnMonth'),
        'alloc-history': () => import('@/components/Allocation/AllocationHistory'),
        'view-all-employees': () => import('@/components/Allocation/AllCompensationEmployees'),
    },
    data () {
        const routeName = this.$route.name
        
        return {
            commonfn,
            awsS3Helper,
            numFormat,
            deductionTypes,
            employeeSectionVisible: userPrefs.getExpandCollapseVisibility(routeName, 'compensation-employee'),
            salarySectionVisible: userPrefs.getExpandCollapseVisibility(routeName, 'compensation-salary'),
            leavesSectionVisible: userPrefs.getExpandCollapseVisibility(routeName, 'compensation-leaves'),
            deminimisSectionVisible: userPrefs.getExpandCollapseVisibility(routeName, 'compensation-deminimis'),
            fringeSectionVisible: userPrefs.getExpandCollapseVisibility(routeName, 'compensation-fringe'),
            otherSectionVisible: userPrefs.getExpandCollapseVisibility(routeName, 'compensation-other'),
            header_compensation: [
                {text: 'Pay Grade',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Monthly Basic Salary',align: 'right',value: '',width: '10%', sortable:false},
                {text: 'Annual Basic Salary',align: 'right',value: '',width: '10%', sortable:false},
                {text: 'OT Pay Eligible',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'ND Pay ELigible',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Effective Date',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Status',align: 'left',value: '',width: '10%', sortable:false}
            ],
            header_compensation_hourly: [
                {text: 'Pay Grade',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Hourly Rate',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'OT Pay Eligible',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'ND Pay Eligible',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Effective Date',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Status',align: 'left',value: '',width: '10%', sortable:false}
            ],  
            headers_leaves: [
                {text: 'Type',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Annual Credits',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Cash Conversion Limit',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Carry-Over Limit',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Pro-Rated',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Status',align: 'left',value: '',width: '10%', sortable:false},
            ],
            header_deminimis: [
                {text: 'Type',align: 'left',value: '',width: '15%', sortable:false},
                {text: 'Payout On',align: 'left',value: '',width: '25%', sortable:false},
                {text: 'Payout Schedule',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Monthly Amount',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Cutoff Amount',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Annual Amount',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Status',align: 'left',value: '',width: '10%', sortable:false}
            ],
            headers_otherbenefits: [
                {text: 'Type',align: 'left',value: '',width: '15%', sortable:false},
                {text: 'Payout On',align: 'left',value: '',width: '20%', sortable:false},
                {text: 'Payout Schedule',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Rate',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Monthly Amount',align: 'right',value: '',width: '5%', sortable:false},        
                {text: 'Cutoff Amount',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Annual Amount',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Status',align: 'left',value: '',width: '10%', sortable:false}
            ],
            headers_fringe: [
                {text: 'Type',align: 'left',value: '',width: '15%', sortable:false},
                {text: 'Payout On',align: 'left',value: '',width: '25%', sortable:false},
                {text: 'Payout Schedule',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Monthly Amount',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Cutoff Amount',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Annual Amount',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Status',align: 'left',value: '',width: '10%', sortable:false}
            ],
            menu_status: false,
            error: false,
            errorMessage: '',
            dialogPreview: false,
            dialogAllocHistory: false,
            dialogAllEmployees: false,
            loading: false,
            loading_pdf: false,
            fiscalYear: null,
            allocation: null,
        }
    },
    methods: {
        viewOtherEmployee(userId){
            this.$router.push(`/compensation/allocation/${this.fiscalPeriodId}/${userId}`)
        },
        showAllEmployees() {
            this.$refs.refAllEmployees.getEmployees()
            this.dialogAllEmployees = true
        },
        managePage(page){
            this.$router.push(`/compensation/allocation/${this.selectedUserId}/${page}`)
        },
        navigateToEmployeeList() {
             this.$router.push(`/compensation/allocation/${this.fiscalPeriodId}`)
        },
        async setSelectedYear(data) {
            this.$router.push(`/compensation/allocation/${data.fiscalPeriodId}/${this.selectedUserId}`)
            await this.getAllocation(false)

            //update header titles
            this.updateHeader()

            //update history 
            this.$refs.updateHistoryRef.getHistory()

            //refresh comments section
            this.$refs.commentsRef.invokeSubscribe()
            this.$refs.commentsRef.getCommentsHistory()
        },
        async copyPrevious() {
            var data = {
                userId: this.selectedUserId,
                fiscalPeriodId: this.fiscalPeriodId
            }
            this.$refs.allocHistoryRef.setData(data)
            this.dialogAllocHistory = true
        },
        async copyHandler(data){
            this.dialogAllocHistory = false
            
            if (!data) this.getAllocation(false)
            else {
                //update url
                this.$router.push(`/compensation/allocation/${data.fiscalPeriodId}/${data.userId}`)

                //update data
                await this.getAllocation(true)

                //update header
                this.updateHeader()                
            }
        },
        updateHeader() {
            //update header titles
            this.$root.$emit('setHeaderTitles', {
                display: true,
                headerTitle: `${this.fiscalYear} Compensation & Benefits`
            })
        },
        async previewPdf() {
            try {
                this.loading_pdf = true
                const response = await allocationApi.getCompPDFUrlByUser(this.fiscalPeriodId, this.selectedUserId, pageKeys.allocation)
                if (response && response.status == 200) {
                    var file = {
                        name: response.data.fileName,
                        type: 'Pdf',
                        url: response.data.url,
                        downloadUrl: awsS3Helper.getEmployeeDocumentUrl(this.selectedUserId, response.data.fileName, AWSS3DocumentType.CompensationAndBenefits)
                    }
                    this.$refs.refPdfPreviewComponet.setParams(file)
                    this.loading_pdf = false
                    this.dialogPreview = true
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId) this.$router.push(`/myprofile`)
            else this.$router.push(`/hr/employees/${data.userId}`)
        },
        is13thMonthPay(data) {
            return data.otherBenefitName == '13th Month'
        },  
        async getAllocation(displayLoading) {
            try {
                this.loading = displayLoading
                const response = await allocationApi.getByUser(this.fiscalPeriodId, this.selectedUserId, pageKeys.allocation)
                if (response && response.status == 200) {
                    // fiscalYear can be saved in UI state from Compensation by Year page,
                    // however this page or the Salary & Pay details page 
                    // can be accessed directly from Notifications page
                    this.fiscalYear = response.data.fiscalYear
                    this.allocation = response.data
                    userPrefs.updateSelectedCompensationYear(this.fiscalYear)
                }
                this.loading = false
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getAllocation(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        await this.getAllocation(true)

        //update header titles
        this.updateHeader()
    },
    watch: {
        employeeSectionVisible(newVal) {
            userPrefs.updateExpandCollapseVisibility(this.$route.name, 'compensation-employee', newVal)
        },
        salarySectionVisible(newVal) {
            userPrefs.updateExpandCollapseVisibility(this.$route.name, 'compensation-salary', newVal)
        },
        leavesSectionVisible(newVal){
            userPrefs.updateExpandCollapseVisibility(this.$route.name, 'compensation-leaves', newVal)
        },
        deminimisSectionVisible(newVal){
            userPrefs.updateExpandCollapseVisibility(this.$route.name, 'compensation-deminimis', newVal)
        },
        fringeSectionVisible(newVal){
            userPrefs.updateExpandCollapseVisibility(this.$route.name, 'compensation-fringe', newVal)
        },
        otherSectionVisible(newVal){
            userPrefs.updateExpandCollapseVisibility(this.$route.name, 'compensation-other', newVal)
        },
        selectedUserId: {
            immediate: true, // runs on first load
            async handler(newUserId, oldUserId) {
                if (!newUserId) return

                // optional guard
                if (newUserId === oldUserId) return

                await this.getAllocation(false)
            }
        }
    },
    computed: {
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return hasApproverRights(this.$router.currentRoute.path)
        },
        pageQueryId() {
            return `alloc${this.fiscalPeriodId}${this.selectedUserId}`
        },
        selectedUserId() {
            return this.$route.params.userId
        },
        fiscalPeriodId() {
            return this.$route.params.fiscalPeriodId
        },
        fiscal_years() {
            if (this.$store.state.fiscalPeriods) {
                return this.$store.state.fiscalPeriods
            }
            return [{fiscalYear: new Date().getFullYear()}]
        },
        commentsData() {
            if (!this.loading) {
                //for refactoring, separate params of comments notif 
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null, 
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.allocation,
                    notificationTypeId: notificationTypes.allocation
                }
            }
        },
        isMobile() {
            return window.innerWidth < 600
        },
        isDeactivted() {
            if (this.allocation)
                return this.allocation.user.employmentStatus == commonfn.getStatusCode('Deactivated')
        },
        isResignedOrTerminated() {
            if (this.allocation)
                return this.allocation.user.employmentStatus == commonfn.getStatusCode('Resigned') ||
                    this.allocation.user.employmentStatus == commonfn.getStatusCode('Terminated')
        },
        hasSalaryAndPay() {
            if (this.allocation) {
                return this.allocation.compensation.length
            }
        },
        isMonthlySalaryType() {
            if (this.allocation) {
                const salaryType = salaryTypes.find(x => x.salaryType == this.allocation.user.salaryType)
                if (salaryType)
                    return salaryType.name == 'Monthly'
                return true
            }
        },
        overallStatus() {
            if (!this.hasSalaryAndPay) {
                return {
                    status: 'Not Available',
                    class: ''
                }
            }

            const APPROVED = commonfn.getStatusCode('Approved')
            const REJECTED = commonfn.getStatusCode('Rejected')

            const statuses = []

            // Multi-record sections
            const collections = [
                this.allocation.compensation,
                this.allocation.leaves,
                this.allocation.deminimis,
                this.allocation.fringeBenefits,
                this.allocation.otherBenefits
            ]

            collections.forEach(list => {
                if (Array.isArray(list) && list.length) {
                    list.forEach(x => statuses.push(x.status))
                }
            })

            const approvedCount = statuses.filter(s => s === APPROVED).length
            const totalCount = statuses.length

            // No records at all
            if (!statuses.length) {
                return {
                    status: 'Not Available',
                    class: ''
                }
            }

            // ❌ Any rejected → Needs Attention
            if (statuses.includes(REJECTED)) {
                return {
                    status: 'Needs Attention',
                    class: 'red--text'
                }
            }

            // ✅ All approved
            if (approvedCount === totalCount) {
                return {
                    status: 'Approved',
                    class: 'green--text'
                }
            }

            // ⏳ None approved yet
            if (approvedCount === 0) {
                return {
                    status: 'Pending',
                    class: 'grey--text'
                }
            }

            // ⚠ Mixed approved & pending
            return {
                status: 'Partially Approved',
                class: 'orange--text'
            }
        }
    }
}
</script>
<style scoped>
.form-data {
    padding:0px 20px 0px 50px;
}
.form-data-mobile {
    padding:0px 0px 0px 10px;
}
.payout-on-container {
    margin-left:-5px;
}
.section-layout {
    padding:5px 23px 5px 23px;
}
</style>